import React, { createContext, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEquipmentTotal } from '../../../features/equipment/equipmentActions';

const TemperatureContext = createContext(null);

export function TemperatureProvider({ children }) {
  const dispatch = useDispatch();
  const equipmentTotal = useSelector(state => state.equipment.totalCount);
  useEffect(() => {
    const request = dispatch(fetchEquipmentTotal());
    return () => request.abort();
  }, [dispatch]);
  return <TemperatureContext.Provider value={{ equipmentTotal }}>{children}</TemperatureContext.Provider>;
}

export function useTemperature() {
  const context = useContext(TemperatureContext);
  if (!context) throw new Error('useTemperature must be used inside TemperatureProvider');
  return context;
}
